import { Building2, User } from "lucide-react";
import { cn } from "@/lib/utils";

export type ContactTypeValue = "all" | "person" | "organization";

const TYPE_OPTIONS: { value: ContactTypeValue; label: string; Icon?: typeof User }[] = [
  { value: "all", label: "All" },
  { value: "person", label: "Person", Icon: User },
  { value: "organization", label: "Organization", Icon: Building2 },
];

interface ContactTypeChipsProps {
  value: ContactTypeValue;
  onChange: (value: ContactTypeValue) => void;
  counts: Record<ContactTypeValue, number>;
}

export function ContactTypeChips({ value, onChange, counts }: ContactTypeChipsProps) {
  return (
    <div role="radiogroup" aria-label="Contact type" className="flex items-center gap-1.5">
      {TYPE_OPTIONS.map((opt) => {
        const Icon = opt.Icon;
        const active = opt.value === value;
        return (
          <button
            key={opt.value}
            type="button"
            role="radio"
            aria-checked={active}
            onClick={() => onChange(opt.value)}
            className={cn(
              "inline-flex h-8 items-center gap-1.5 rounded-full border px-3 text-xs font-medium transition-colors",
              active
                ? "border-foreground bg-foreground text-background"
                : "border-border bg-background text-foreground hover:bg-muted",
            )}
          >
            {Icon ? <Icon className="h-3.5 w-3.5" /> : null}
            <span>{opt.label}</span>
            <span
              className={cn(
                "tabular-nums",
                active ? "text-background/70" : "text-muted-foreground",
              )}
            >
              · {counts[opt.value]}
            </span>
          </button>
        );
      })}
    </div>
  );
}
